import { defineComponent } from 'vue';
import CrmIdCode from '@/presentation/components/campaign-management/crm-id/crm-id.code';

export default defineComponent({
	setup: () => {
		const code = new CrmIdCode();
		return {
			storedCrmId: code.storedCrmId,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldValidatedAndInvalid: code.isFieldValidatedAndInvalid,
			setCrmIdBasedOnEvent: code.setCrmIdBasedOnEvent.bind(code)
		};
	}
});
